import { create } from 'zustand';
import _ from 'lodash';

interface initDataState {
  param: any;
  bindParam: any;
  result: any;
  initPayload: any;
  payload: any;
  bind: (result: { data: any }) => void;
  bindPayload: (payload: { data: any }) => void;
}

export const initEducationPayload = {
  name: '', //사용자명
  acct_year: '', //연말정산   년도
  co_cd: '', //회사코드
  co_id: '', //사번
  in_data_seqid: '', //입력데이터 sequence
  family_seqid: 0, //부양가족 sequence
  amt: 0, // 의료비(일반)
  htx_amt: 0, //의료비(국세청)
  htx_expt_amt: 0, //국세청 PDF 제외금액
  data_type: '', //구분
  is_htx_pdf: 'Y', //국세청 PDF 자료여부
};

/**
  신용카드
**/
export const educationDataStore = create<initDataState>(set => ({
  param: { initialSeq: 0 },
  bindParam: (bind: any) =>
    set(state => ({
      ...state,
      param: { ...state.param, ...bind },
    })),
  result: [],
  bind: (data: any) =>
    set(state => ({
      ...state,
      result: { ...state.result, ...data },
    })),
  initPayload: initEducationPayload,
  payload: _.cloneDeep(initEducationPayload),
  bindPayload: (data: any) =>
    set(state => ({
      ...state,
      payload: { ...state.payload, ...data },
    })),
}));
